<template>
  <v-container class="mt-0">
    <v-layout row wrap justify-center class="mt-3">
      <v-flex xs12 class="text-xs-center">
        <h1>Trials By {{ investigators }}</h1>
          <v-alert v-if="trials == false" color="info" icon="new_releases" :value="true">
            There are no trials for the {{ investigators }} investigator.
          </v-alert>
      </v-flex>
      <v-flex xs12 align-content-space-between mt-4 mb-0 ml-0 mr-0>
        <v-card class="info" v-for="(item, index) in trials" v-bind:key="item.trialId"  :to="'/trials/' + item.trialId">
          <v-list class="listItems">
              <v-list-tile class="pl-2" avatar>
                  <v-list-tile-avatar>
                    <span class="status">
                      <span :class="enrollment(index).enrollmentName"></span><br>
                    </span>
                  </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ item.trialName }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title><span>{{ enrollment(index).enrollmentName }}</span><span> - {{ locations(index).locationName }}</span></v-list-tile-sub-title>
                  <!-- <v-list-tile-sub-title>{{ item.trialDate | date }}</v-list-tile-sub-title> -->
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn light flat icon right ripple :to="'/trials/' + item.trialId">
                    <right-icon small v-bind:color="item.active ? 'primary' : 'grey'" class="icon" />
                  </v-btn>
                </v-list-tile-action>
                <v-list-tile-action class="" v-if="userIsAuthenticated">
                  <v-btn light icon right flat :to="'/trials/' + item.trialId + '/edit'" class="">
                    <v-icon small light class="text--lighten-2">edit</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 mb-4 v-if="userIsAuthenticated">
        <v-card :to="'/trial/new'">
          <v-card-text class="cyanLight editDialogsRow" v-if="userIsAuthenticated">
            Add Trial
            <v-icon class="text-xs-right">add</v-icon>
          </v-card-text>                             
        </v-card>
      </v-flex>       
    </v-layout>	
  </v-container>
</template>
<script>
export default {
  props: ['investigatorId'],
  data () {
    return {
    }
  },
  computed: {
    trials () {
      var loadedTrialss = this.$store.getters.loadedTrialsByInvestigator(this.investigatorId)
      return loadedTrialss.sort((a, b) => {
        var EPa = this.$store.getters.loadedEnrollment(a.trialEnrollment)
        var EPb = this.$store.getters.loadedEnrollment(b.trialEnrollment)
        return (EPa.enrollmentPriority > EPb.enrollmentPriority) ? 1 : ((EPb.enrollmentPriority > EPa.enrollmentPriority) ? -1 : 0)
      })
    },
    userIsAuthenticated () {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined
    },
    investigators () {
      if (typeof this.$store.getters.loadedInvestigator(this.investigatorId) !== 'undefined') {
        var locaName = this.$store.getters.loadedInvestigator(this.investigatorId)
        return locaName.investigatorName
      }
    }
  },
  methods: {
    enrollment (index) {
      console.log('CURRENT loadedEnrollment ITEM: ' + this.$store.getters.loadedEnrollment(this.trials[index].trialId))
      var val = this.$store.getters.loadedEnrollment(this.trials[index].trialEnrollment)
      return val
    },
    locations (index) {
      console.log('CURRENT loadedLocation ITEM: ' + this.$store.getters.loadedLocation(this.trials[index].trialLocations))
      var val = this.$store.getters.loadedLocation(this.trials[index].trialLocations[0])
      return val
    },
    onDeleteTrial (trial) {
      this.$store.dispatch('deleteTrialData', trial)
      this.$router.push('/trials')
    }
  }
}
</script>

<style lang="scss" scoped>
  span.status{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding-right: 15px;
    span{
      height: 15px;
      width: 15px;
      border-radius: 15px;
      &.Enrolling{
        background: green;
      }
      &.Not.Enrolling{
        background: red;
      }
      &.Pending {
        background: orange;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Singular.vue?6148b53e